import { FeelingColors } from "../../Colors";

const StackedHorizontalBar = ({ greenPercentage, redPercentage }) => {
    return (
        <div style={{ width: "85%", display: "flex", borderRadius: "0.6rem", background: "rgba(246, 246, 246, 0.6)", padding: "2px" }}>
            <div style={{
                background: FeelingColors.Good,
                width: `${greenPercentage}%`,
                height: '2rem',
                borderTopLeftRadius: "0.5rem",
                borderBottomLeftRadius: "0.5rem"
            }}></div>
            <div style={{
                background: FeelingColors.Unpleasant,
                width: `${redPercentage}%`,
                height: '2rem',
                borderTopRightRadius: "0.5rem",
                borderBottomRightRadius: "0.5rem"
            }}></div>
        </div>
    )
};

export default StackedHorizontalBar;
